import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, AlertX, ColorX, GFunc, LocaleX, NavX, ResponsiveX, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XImage, XText } from "IZOX/_X";
import { QFDigitBox, QFPassword } from "IZOX/BLOCKS/Libs/QForm/_gears";
import { QForm } from "IZOX/BLOCKS/Libs";
import _ from "lodash";
import Styles from "__SYSDefault/Styles";
import CountDownLite from "IZOX/BLOCKS/Libs/RefreshTimeCount/CountDownLite";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import Password from "shared/Password";
import FooterM from "shared/FooterM";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PChangePassword extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      curStep: 0
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._GetInfo();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PChangePassword.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  onMountCountDown = (callbacks) => {
    this.MountCountDown = callbacks;
  }

  onMountQFEmailPassword = (callbacks) => {
    this.MountQFEmailPassword = callbacks;
  }

  onMountQFOTP = (callbacks) => {
    this.MountQFOTP = callbacks;
  }

  _GetInfo = async () => {
    let info = await APIExpress.WebSettings.GetInfo();
    this.setState({
      info: info
    });
  }

  _updateFormData = (_formValue) => {
    let {formValue} = this.state;
    let newFormData = {
     ...formValue,
     ..._formValue
    };
    this.setState({
      formValue: newFormData
    });
    return newFormData;
  }

  _canResend = () => {
    this.setState({
      canResend: true
    });
  }

  _resendOTP = async () => {
    let {formValue} = this.state;
    let userID = Accessor.Get(formValue, "userID");
    let res = await APIExpress.OTP.Resend(userID, "ChangePassword");
    let {Success, payload} = res;
    if(!Success){
      return;
    }

    this.MountCountDown?.Reset?.();
    this.setState({
      canResend: false
    });
    
    let {requestID} = payload;
    this._updateFormData({
      requestID: requestID
    });
  }

  _autoVerifyOTP = async (otp) => {
    let {formValue} = this.state;
    let oldPassword = Accessor.Get(formValue, "oldPassword");
    let password = Accessor.Get(formValue, "password");
    let requestID = Accessor.Get(formValue, "requestID");

    let res = await APIExpress.OTP.Verify(GFunc.GetSELFUserID(), requestID, "ChangePassword", otp);
    let {Success} = res;

    if(Success){
      let authCode = res.payload;
      let verRes = await APIExpress.AuthCode.VerifyChangePassword(authCode, password, oldPassword);
      if(verRes.Success){
        let logged = GFunc.Login(verRes.payload);
        if(logged.Success){
          this._toStep(2);
        }
      }else{
        GFunc.Alert(verRes.payload?.message, "error");
        this.MountQFOTP?.Clear?.();
      }
    }else{
      AlertX.TryAgainLater();
      this.MountQFOTP?.Clear?.();
    }
  }

  _apply = async () => {
    let {formValue} = this.state;
    let {Success, error} = this._checkEPFormValid(formValue);
    if(error) GFunc.Alert(error, "error");
    if(!Success) return;
    let res = await APIExpress.User.ChangePassword(formValue);
    if(!res.Success){
      return;
    }
    let {userID, requestID} = res.payload;
    this._updateFormData({
      userID: userID,
      requestID: requestID
    });
    this._toStep(1);
  }

  _checkEPFormValid = (formValue) => {

    let errors = Password.CheckIfErrors(formValue, "password");

    if(!_.isEmpty(errors)){
      let msgEN = _.map(errors, o => LocaleX.Parse(o, undefined, "EN")).join("\n");
      let msgTC = _.map(errors, o => LocaleX.Parse(o, undefined, "TC")).join("\n");
      return {
        Success: false,
        error: {
          EN: "Password must be:\n" + msgEN,
          TC: "密碼必需為:\n" + msgTC
        }
      };
    }

    let valid = ZValidate.CheckAllFields(formValue, 
      ["oldPassword", "password", "confirmPassword"],
      "required"
    );
    if(!valid) {
      return {
        Success: false,
        error: {
          EN: "Some fields are empty.",
          TC: "有些欄位沒有填妥"
        }
      };
    } 
    
    if(!Accessor.IsAllFieldIdentical(formValue, ["password", "confirmPassword"])){
      return {
        Success: false,
        error: {
          EN: "Password not match.",
          TC: "密碼不匹配"
        }
      };
    }

    return {
      Success: true
    };
  }

  _toStep = (step) => {
    this.setState({
      curStep: step
    });
  }

  _toRedirect = () => {
    let {history} = this.props;
    NavX.Goto(history, "/User/Redirect");
  }

  renderEmailPassword(){
    let {epFormValid, error} = this.state;
    return (
      <QForm maxWidth={"80%"} width={416} fullHeight VAlign="^" pT={30} 
        spacing={16} onMounted={this.onMountQFEmailPassword} zIndex={1}
        onChange={(formValue) => {
          let _new = this._updateFormData(formValue);
          let {Success, error} = this._checkEPFormValid(_new);
          this.setState({
            epFormValid: Success,
            error: error
          });
        }}>
        {ResponsiveX.Split({
          0: null,
          [SysConfig.WebUIWidth]: () => <XImage source="/Images/home/logoV.png"/>
        })}
        <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
          {LocaleX.Parse({
            EN: "Change Password",
            TC: "變更密碼"
          })}
        </XText>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Old Password",
                TC: "舊密碼"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFPassword
            name="oldPassword"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your old password here.",
              TC: "請在此輸入您的舊密碼。",
            })}
            />
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "New Password",
                TC: "新密碼"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFPassword
            name="password"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please enter your new password here.",
              TC: "請在此輸入您的新密碼。",
            })}
            />
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={5}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Confirm Password",
                TC: "確認密碼"
              })}
            </XText>
            <XText fontSize={12} color={ColorX.CSS("Blood")}>
              {"*"}
            </XText>
          </HStack>
          <QFPassword
            name="confirmPassword"
            fontSize={14}
            p={12}
            bColor={ColorX.CSS("NotQuiteWhite")}
            placeholder={LocaleX.Parse({
              EN: "Please re-enter your password here.",
              TC: "請在此重新輸入您的新密碼。",
            })}
            />
        </VStack>
        <XButton {...Styles.QFBtn} fullWidth
          onPress={this._apply} disabled={!epFormValid}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Apply Change",
                TC: "套用變更"
              })}
            </XText>
          </HStack>
        </XButton>
        {!_.isEmpty(error)
          && 
          <XText color={ColorX.CSS("Blood")} fontSize={12} textAlign="[" fullWidth>
            {"*" + LocaleX.Parse(error)}
          </XText>
        }
      </QForm>
    );
  }

  renderOTP(){
    let {canResend} = this.state;
    return (
      <QForm spacing={24} fullHeight VAlign="-" pB={120} zIndex={1}
        onMounted={this.onMountQFOTP}>
        <VStack>
          <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
            {LocaleX.Parse({
              EN: "Verify Your Account",
              TC: "驗證您的帳戶"
            })}
          </XText>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")} textAlign="|">
            {LocaleX.Parse({
              EN: "Enter the 6-digit verification code sent to your registered email address",
              TC: "輸入發送到您註冊電子郵件地址的 6 位驗證碼"
            })}
          </XText>
        </VStack>
        <QFDigitBox onDigitEnd={this._autoVerifyOTP} 
          digit={6} name="otp"
          color={ColorX.CSS("Stone")}
          fontSize={30}
          p={12}
          boxWidth={ResponsiveX.Split({0: () => 36, [SysConfig.WebUIWidth]: () => 48})}
          boxHeight={ResponsiveX.Split({0: () => 36, [SysConfig.WebUIWidth]: () => 48})}
          bColor={ColorX.CSS("NotQuiteWhite")}/>
        <VStack>
          <XText fontSize={14} color={ColorX.CSS("pureWhite")}>
            {LocaleX.Parse({
              EN: "Didn't receive one-time code?",
              TC: "沒有收到一次性代碼？"
            })}
          </XText>
          <XButton onPress={this._resendOTP} disabled={!canResend}>
            <HStack>
              <XText color={ColorX.CSS("DeepBlueSea")} fontSize={16} bold>
                {LocaleX.Parse({
                  EN: "Resend",
                  TC: "重發"
                })}
              </XText>
              {!canResend && 
                <HStack fitWidthToContent>
                  <XText>{"("}</XText>
                  <CountDownLite onMounted={this.onMountCountDown}
                    countDown={60} onTimeUp={this._canResend}/>
                  <XText>{")"}</XText>
                </HStack>}
            </HStack>
          </XButton>
        </VStack>
      </QForm>
    );
  }

  renderThankYou(){
    return (
      <VStack fullHeight VAlign="-" spacing={24} zIndex={1}>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")} bold>
          {LocaleX.Parse({
            EN: "Password Changed",
            TC: "密碼已變更"
          })}
        </XText>
      </VStack>
    );
  }

  renderStep(){
    let {curStep} = this.state;
    switch(curStep){
      default: case 0: return this.renderEmailPassword();
      case 1: return this.renderOTP();
      case 2: return this.renderThankYou();
    }
  }

  render(){
    return (
      <VStack flexGrow={1} bgColor={ColorX.CSS("Grass")} fullWidth fullHeight>
        <XImage source="/Images/static/pattern.png" noResize maxWidth={"50%"} height={"auto"}
          position="absolute" style={{bottom: 0, right: 0}} zIndex={0}/>
        {this.renderStep()}
        {ResponsiveX.Split({0: () => <FooterM/>, [SysConfig.WebUIWidth]: () => null})}
      </VStack>
    );
  }

}

export default observer(PChangePassword);
